export const AREA_INSTRUCTIONS = 'instructions';
export const AREA_SEQUENCE_CARDS = 'sequenceCards';
export const AREA_RESPONSE_CARDS = 'responseCards';

export const SECTION_IMAGE = 'image';
export const SECTION_TEXT = 'text';
export const SECTION_AUDIO = 'audio';
export const SECTION_ANSWER_KEY = 'answer_key';
